import Event from '../domain/Event.js';

let MYEFC_AUTH_COOKIE_NAME = 'myEfcCookieAuth';

class RegisterHandler {

  constructor(controller, registerValidator, requestBuilder, httpService, trackingService, cookieUtils, utils) {

    this.controller = controller;
    this.registerValidator = registerValidator;
    this.requestBuilder = requestBuilder;
    this.httpService = httpService;
    this.trackingService = trackingService;
    this.cookieUtils = cookieUtils;
    this.utils = utils

  }

  handleSubmit(requestToken, emailAddress, askForEmailForRegister) {

    this.controller.startActionInProgress();

    this.controller.setState({
      formInProgress: 'REGISTER'
    });

    this.registerValidator.validate(requestToken, emailAddress, askForEmailForRegister);

    let registerRequest = this.requestBuilder.getRegisterRequest(requestToken, askForEmailForRegister ? emailAddress : null);

    return this.httpService.post(registerRequest)
      .then((response) => {

        switch (response.status) {
          case 200:
            process200Response.bind(this)(response);
            break;
          default:
            return process201Response.bind(this)(response, emailAddress);
        }

      });

  }

}

let process200Response = function (response) {

  this.controller.setState({
    requestToken: response.data.request_token
  });

  this.controller.showLinkAccountPage();

};

let process201Response = function (response, emailAddress) {

  this.cookieUtils.set(MYEFC_AUTH_COOKIE_NAME, response.data.access_token, {secure: true, domain: this.utils.getCookieDomain(), path: '/', expires: response.data.expires_in});
  this.trackingService.submitEvent(Event.ACCOUNT_CREATION_WITH_OPENID, {emailAddress: emailAddress});
  this.controller.handleSuccess(response.data);

  return response;

};

export default RegisterHandler;



// WEBPACK FOOTER //
// ./src/library/handlers/RegisterHandler.js